import React, { useMemo } from "react";
import { DetailsSectionProps } from "./types";
import Button from "../../atoms/Buttons/Button/Button";

const DetailsSection: React.FC<DetailsSectionProps> = ({
  contentDetails = [],
  DetailsValueGenerator,
  handleMainButtonClick,
  BUTTONS = [],
  title,
}) => {
  // Generate initials from title (assuming title = "FirstName LastName")
  const initials = useMemo(() => {
    if (!title) return "";

    const parts = title.trim().split(" ");
    const first = parts[0]?.charAt(0) || "";
    const second = parts[1]?.charAt(0) || "";

    return `${first}${second}`.toUpperCase();
  }, [title]);

  return (
    <div className="jobs-details-section">
      <div className="box-container">
        {title && (
          <div className="headline-section border-0 mt-2 d-flex align-items-center gap-2">
            <div className="avatar">{initials}</div>
            <div>{title}</div>
          </div>
        )}

        <div className="content-section-details">
          {contentDetails.map((item) => (
            <div className="details-area" key={item.label}>
              <div className="heading">{item.label}</div>
              <div className="content-details">
                {DetailsValueGenerator(item)}
              </div>
            </div>
          ))}
        </div>
      </div>

      {!!BUTTONS.length && (
        <div className="footer-section box-container">
          {BUTTONS.map((button) => (
            <Button
              key={button.name}
              cssClass={button.className}
              text={button.name}
              onClick={() => handleMainButtonClick(button.name)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default React.memo(DetailsSection);
